// extracted by mini-css-extract-plugin
export default {"main":"Main_main__o9BN0","container":"Main_container__6HwWs","left__area":"Main_left__area__Qktux","left__menu":"Main_left__menu__401S5","main__area":"Main_main__area__HryE0"};